export class KEYBOARD_KEYS {
  static readonly ENTER = 'Enter';
}

export const NEW_ROW_ID = 'newRow';
